import React from "react"
import HeaderSection from "../../components/header-section"
import Sidebar from "../../features/sidebar/components/sidebar"
import SimulationManagement from "../../features/admin/components/simulation-management"
import { MdOutlinePlayCircle } from "react-icons/md"

// Icon wrapper component for TypeScript compatibility
// @ts-expect-error - React icons return ReactNode which is valid for JSX
const PlayIcon = (props: { size?: number; className?: string }): JSX.Element => <MdOutlinePlayCircle {...props} />

const SimulationsLibraryPage: React.FC = () => {
  return (
    <div className="flex bg-[#F9FAFB] min-h-screen w-full overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <HeaderSection />
        <main className="flex-1 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto">
            {/* Page Header */}
            <div className="mb-8">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-indigo-100 rounded-lg">
                  <PlayIcon size={24} className="text-indigo-600" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    Simulations Library
                  </h1>
                  <p className="text-gray-500">
                    Manage simulation definitions, images, and metadata
                  </p>
                </div>
              </div>
            </div>

            {/* SimulationManagement CRUD Component */}
            <SimulationManagement />
          </div>
        </main>
      </div>
    </div>
  )
}

export default SimulationsLibraryPage
